// user
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOADED = 'USER_LOADED';
export const USER_LOADING = 'USER_LOADING';
export const USER_REGISTERED = 'USER_REGISTERED';
export const USER_REGISTERING = 'USER_REGISTERING';
export const USER_RESETTING = 'USER_RESETTING';
export const USER_VERIFIED = 'USER_VERIFIED';
export const USER_VERIFYING = 'USER_VERIFYING';
export const USER_FB_TOKEN = 'USER_FB_TOKEN';
export const MEMBERS_LOADING = 'MEMBERS_LOADING';
export const MEMBERS_LOADED = 'MEMBERS_LOADED';
export const UPDATE_PRESENTATION_DETAIL = 'UPDATE_PRESENTATION_DETAIL';
export const HANDLE_PRESENTATION_DETAIL_ERROR =
  'HANDLE_PRESENTATION_DETAIL_ERROR';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const HANDLE_TOKEN_ERROR = 'HANDLE_TOKEN_ERROR';
export const SET_COMPARE_ADS = 'SET_COMPARE_ADS';
export const UPDATE_COMPARE_ADS = 'UPDATE_COMPARE_ADS';
export const SET_COMPARE_CAMPAIGNS = 'SET_COMPARE_CAMPAIGNS';
export const UPDATE_ACCORDION_INDEX = 'UPDATE_ACCORDION_INDEX';
export const UPDATE_AD_SELECTED_INDEX = 'UPDATE_AD_SELECTED_INDEX';

// ad preview actions
export const AD_PREVIEW_DISPLAY_COPY_BUTTONS =
  'AD_PREVIEW_DISPLAY_COPY_BUTTONS';
export const AD_PREVIEW_COMPARE_MOBILE_DESKTOP =
  'AD_PREVIEW_COMPARE_MOBILE_DESKTOP';
export const AD_PREVIEW_UPDATE_ACCORDION_INDEX =
  'AD_PREVIEW_UPDATE_ACCORDION_INDEX';
export const AD_PREVIEW_EXPAND_ALL = 'UPDATE_AD_SELECTED_INDEX';
export const AD_PREVIEW_SELECT_ADS = 'AD_PREVIEW_SELECT_ADS';
export const AD_PREVIEW_DISPLAY_CHECKBOX = 'AD_PREVIEW_DISPLAY_CHECKBOX';
export const AD_PREVIEW_DISPLAY_CHECKBOX_MULTIQC =
  'AD_PREVIEW_DISPLAY_CHECKBOX_MULTIQC';
export const AD_PREVIEW_SELECT_CAMPAIGNS = 'AD_PREVIEW_SELECT_CAMPAIGNS';
export const AD_PREVIEW_INDETERMINATE_CAMPAIGNS =
  'AD_PREVIEW_INDETERMINATE_CAMPAIGNS';
export const AD_PREVIEW_UPDATE_ALL = 'AD_PREVIEW_UPDATE_ALL';
export const AD_COMPARER_UPDATE_ACCORDION_INDEX =
  'AD_COMPARER_UPDATE_ACCORDION_INDEX';
export const AD_PREVIEW_SCROLLING = 'AD_PREVIEW_SCROLLING';

// ad qc actions
export const AD_QC_INIT_CAMPAIGN_TOTAL = 'AD_QC_UPDATE_TOTAL';
export const AD_QC_UPDATE_TOTAL = 'AD_QC_UPDATE_TOTAL';

// ad comparer
export const AD_COMPARER_INIT_CAMPAIGN_TOTAL =
  'AD_COMPARER_INIT_CAMPAIGN_TOTAL';
export const AD_COMPARER_UPDATE_TOTAL = 'AD_COMPARER_UPDATE_TOTAL';

// ad share
export const AD_SHARE_FETCH_LOB = 'AD_SHARE_FETCH_LOB';
export const AD_SHARE_FETCH_LOB_SUCCESS = 'AD_SHARE_FETCH_LOB_SUCCESS';
export const AD_SHARE_FETCH_LOB_ERROR = 'AD_SHARE_FETCH_LOB_ERROR';
export const AD_SHARE_DELETE_ACCOUNT = 'AD_SHARE_DELETE_ACCOUNT';
export const AD_SHARE_FETCH_POST = 'AD_SHARE_FETCH_POST';
export const AD_SHARE_FETCH_POST_SUCCESS = 'AD_SHARE_FETCH_POST_SUCCESS';
export const AD_SHARE_FETCH_POST_ERROR = 'AD_SHARE_FETCH_POST_ERROR';

// ad import
export const AD_IMPORT_FETCH_HTML = 'AD_IMPORT_FETCH_HTML';
export const AD_IMPORT_FETCH_HTML_SUCCESS = 'AD_IMPORT_FETCH_HTML_SUCCESS';
export const AD_IMPORT_FETCH_HTML_ERROR = 'AD_IMPORT_FETCH_HTML_ERROR';
export const AD_IMPORT_INSERT = 'AD_IMPORT_INSERT';
export const AD_IMPORT_INSERT_SUCCESS = 'AD_IMPORT_INSERT_SUCCESS';
export const AD_IMPORT_INSERT_ERROR = 'AD_IMPORT_INSERT_ERROR';
export const AD_IMPORT_FETCH_PRESENTATION = 'AD_IMPORT_FETCH_PRESENTATION';
export const AD_IMPORT_FETCH_PRESENTATION_SUCCESS =
  'AD_IMPORT_FETCH_PRESENTATION_SUCCESS';
export const AD_IMPORT_FETCH_PRESENTATION_ERROR =
  'AD_IMPORT_FETCH_PRESENTATION_ERROR';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js